import api from '../api';

class DataServiceNewsletter {
  getNewsletters() {
    return api.get('newsletters');
  }

  getNewsletterById(id) {
    return api.get(`newsletters/${id}`);
  }

  getSubplatforms() {
    return api.get('newsletters/companies');
  }

  addNewsletter(data) {
    return api.post('newsletters', data);
  }

  updateNewsletter(id, data) {
    return api.put(`newsletters/${id}`, data);
  }

  deleteNewsletter(id) {
    return api.delete(`newsletters/${id}`);
  }
}

export default new DataServiceNewsletter();
